type ConfirmationHandler = (message: string, answer: (accepted: boolean) => void) => void;
let handler: ConfirmationHandler | undefined;

/** History owns the pending transition, including Back/Forward and location state. */
export function confirmNavigation(message: string, answer: (accepted: boolean) => void) {
  if (handler) handler(message, answer);
  else answer(window.confirm(message));
}

export function registerNavigationConfirmation(next: ConfirmationHandler) {
  handler = next;
  return () => { if (handler === next) handler = undefined; };
}
